import * as React from 'react'
import Layout from '../shared/Layout'
import { AddToWallet } from './sections/AddToWallet'
import { Economy } from './sections/Economy'
import { GetData } from './sections/GetData'
import { Hero } from './sections/Hero'
import { Metrics } from './sections/Metrics'
import { OnChainMetrics } from './sections/OnChainMetrics'

export function DataTokenPage() {
    return (
        <Layout>
            <Hero />
            <Economy />
            <OnChainMetrics />
            <Metrics />
            <AddToWallet />
            <GetData />
        </Layout>
    )
}
